"use strict";
var hlp = require('common/helpers');
var TypeMap = {
  'B': 'szene',
  'S': 'person',
  'O': 'objekt',
  'T': 'koerperteil',
  'K': 'kleidung',
  'H': 'handlung',
  'HO': 'historort'
};
var LinkTypeMap = {'cross': 'cross'};
var Processor = function(environment) {
  this.process = function(parsed) {
    console.log("Process: ", parsed);
    switch (parsed.type) {
      case 'entity':
        var entity = getEntity(parsed.entity);
        environment.selectEntityFromCommandLine(entity.id);
        var type = parsed.entity_type ? getEntityType(parsed.entity_type) : null;
        var fields = mapFields(type ? type : entity.typ, parsed.fields);
        if (hlp.isSet(type)) {
          console.log("Adding entity of type " + type);
          environment.runAddEntity(entity, type, parsed.relation_type, fields);
        } else {
          console.log("Modifying entity");
          environment.runUpdateEntity(entity, fields);
        }
        break;
      case 'relations':
        var entity = parsed.entity1 ? parsed.entity1 : environment.getActiveEntity().id;
        environment.runLinkEntities(entity, parsed.entity2, parsed.relation_type, "cross");
        break;
    }
    ;
    return null;
  };
  var getEntity = function(id) {
    if (!id) {
      var entity = environment.getActiveEntity();
      if (!entity)
        entity = environment.entities[0];
      return entity;
    }
    if (id[0] == '<') {
      var entity = environment.getActiveEntity();
      var levels = id.length;
      while (entity != null && levels-- > 0)
        entity = entity.parent;
      if (!entity)
        throw "Fehler, konnte Entität '" + id + "' nicht ermitteln";
      else
        return entity;
    } else {
      var entity = environment.getEntityById(id);
      if (entity == null)
        throw "Fehler, Entität '" + id + "' nicht gefunden";
      else
        return entity;
    }
    return entity;
  };
  var getEntityType = function(type) {
    if (!type)
      throw "Leerer Entitätstyp nicht erlaubt";
    type = type.toUpperCase();
    if (typeof TypeMap[type] != 'undefined') {
      return TypeMap[type];
    }
    throw "Unbekannter Entitätstyp \"" + type + "\"";
  };
  var mapFields = function(type, fields) {
    var mapped = {metadata: {}};
    var i = 0;
    for (var key in environment.schema[type].fields) {
      mapped[key] = [];
      if (hlp.isSet(fields[i])) {
        var field = fields[i];
        mapped = mapEntries(mapped, key, field);
      }
      i++;
    }
    if (i < fields.length) {
      throw ("Zu viele Felder für Typ " + environment.schema[type].label + ", max. " + i + " erwartet, " + fields.length + " angegeben");
    }
    return mapped;
  };
  var mapEntries = function(mapped, key, field) {
    for (var j = 0; j < field.length; j++) {
      var entry = field[j];
      mapped[key][j] = entry.value;
      if (!hlp.isSet(mapped['metadata'][key])) {
        mapped['metadata'][key] = [];
      }
      if (!hlp.isSet(mapped['metadata'][key][j])) {
        mapped['metadata'][key][j] = {};
      }
      mapped['metadata'][key][j] = mapEntryMetadata(entry, mapped['metadata'][key][j]);
    }
    return mapped;
  };
  var mapEntryMetadata = function(entry, metadata) {
    for (var key2 in entry) {
      if (key2 != 'value') {
        if (key2 == 'comments' && entry[key2] != null) {
          metadata[key2] = [{text: entry[key2]}];
        } else if (key2 == 'flags' && entry[key2] != null) {
          metadata[key2] = {};
          if (entry[key2].indexOf('!') > -1) {
            metadata[key2]["remarkable"] = true;
          }
          if (entry[key2].indexOf('?') > -1) {
            metadata[key2]["unconfirmed"] = true;
          }
        } else {
          metadata[key2] = entry[key2];
        }
      }
    }
    return metadata;
  };
  return this;
};
Processor.TypeMap = TypeMap;
Processor.LinkTypeMap = LinkTypeMap;
module.exports = Processor;
